import { DateType } from "../types";

function getDateDaysNumber(year: number, month: number): number {
  return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}

function getWeek({ year, month }: DateType): string[][] {
  const numDays = getDateDaysNumber(year, month);
  const week: string[][] = [[], [], [], [], [], [], []];

  for (let i = 1; i <= numDays; i++) {
    const date = new Date(Date.UTC(year, month, i));
    const dayIndex = date.getUTCDay() === 0 ? 6 : date.getUTCDay() - 1;

    if (i === 1) {
      for (let j = 0; j < dayIndex; j++) {
        week[j].push("");
      }
    }

    week[dayIndex].push(i.toString(10));

    if (i === numDays) {
      for (let j = dayIndex + 1; j < 7; j++) {
        week[j].push("");
      }
    }
  }

  return week;
}

function getDaysTexts(t: Function) {
  return [
    t("calendar.monday"),
    t("calendar.tuesday"),
    t("calendar.wednesday"),
    t("calendar.thursday"),
    t("calendar.friday"),
    t("calendar.saturday"),
    t("calendar.sunday"),
  ];
}

export { getWeek, getDaysTexts };
